import { __ } from '@wordpress/i18n';
import { PlusIcon, MinusIcon, ResetIcon } from '../icons/icons';

/**
 * Zoom Controls.
 *
 * @param {Object}   props              - component props
 * @param {Function} props.zoomCallback - zoom callback function. This function will be called with the type of zoom action: "zoomIn", "zoomOut", or "zoomReset".
 * @return {*} jsx
 */
export function ZoomControls( { zoomCallback }: { zoomCallback: Function; } ): any {
	return (
		<div className="tcc-map__zoom-controls">
			<button className="zoom-in" onClick={ () => {
				zoomCallback( 'zoomIn' );
			} }>
				<PlusIcon />
				<span className="screen-reader-text">{ __( 'Zoom In', 'tcc-map' ) }</span>
			</button>
			<button
				className="zoom-reset"
				onClick={ () => {
					zoomCallback( 'zoomReset' );
				} }
			>
				<ResetIcon />
				<span className="screen-reader-text">{ __( 'Reset Zoom', 'tcc-map' ) }</span>
			</button>
			<button className="zoom-out" onClick={ () => {
				zoomCallback( 'zoomOut' );
			} }>
				<MinusIcon />
				<span className="screen-reader-text">{ __( 'Zoom Out', 'tcc-map' ) }</span>
			</button>
		</div>
	);
}
